module.exports = __webpack_public_path__ + "img/aa89ad0.jpg";